const useStyles = (theme) => ({
  accordion: {
    width: "100%",
    boxShadow: "0px 0px 5px  #0000001a",
    "&::before": {
      display: "none",
    },
  },
  sumary: { flexDirection: "row-reverse", gap: 1 },
  boxCard: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    width: "100%",
    "@media (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  card: {
    width: "120px",
    position: "relative",
    height: "180px",

    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  cardAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "180px",
    padding: "20px",
    gap: 1,
  },
  icon: {
    fontSize: "45px",
  },
  title: {
    fontSize: "18px",
    fontWeight: 500,
  },
  confirmButton: {
    color: theme?.palette?.color?.buttonConfirm || "primary.main",
  },
  dialogContent: {
    width: { xs: "300px", md: "400px" },
    minWidth: "250px",
    maxWidth: "100%",
  },
  textfield: {
    maxWidth: "100%",
    mb: "10px",
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      boxShadow: "none",

      "&:hover": {
        backgroundColor: theme.palette.background.paperLinkedMaps,
      },
    },
  },
});

export default useStyles;
